import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CustomParamsDialogComponent } from '@go-modules/components/dialogs/custom-params-dialog/custom-params-dialog.component';
import { CopyToClipboardDirectiveModule } from '@go-modules/directives/go-clipboard/copy-to-clipboard.module';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		GoMaterialModule,
		CopyToClipboardDirectiveModule
	],
	declarations: [
		CustomParamsDialogComponent
	],
	exports: [
		CustomParamsDialogComponent
	]
})
export class CustomParamsDialogModule {}
